<template>
  <div class="d-flex position-relative" style="gap: 12px; padding: 12px 0" :data-notification-id="notification.id">
    <!-- Category icon -->
    <div class="flex-shrink-0 position-relative" style="width: 40px; height: 40px">
      <img :src="notification.iconSrc" alt="" style="width: 40px; height: 40px; border-radius: 100px" />
      <!-- Unread red dot -->
      <div
        v-if="!notification.isRead"
        class="position-absolute"
        style="width: 12px; height: 12px; border-radius: 50%; background-color: #cc2f2f; left: 28px; top: 0"
      />
    </div>

    <!-- Text content -->
    <div class="flex-grow-1" style="min-width: 0">
      <!-- Title -->
      <div
        style="
          font-family: Arial, sans-serif;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: -0.48px;
          color: #000000;
        "
      >
        {{ notification.title || 'Notification' }}
      </div>
      <!-- Body -->
      <div
        class="notification-body"
        style="font-family: Arial, sans-serif; font-size: 16px; line-height: 24px; color: #000000"
        v-html="notification.body"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.notification-body {
  overflow-wrap: break-word;
  word-break: break-word;
}

.notification-body :deep(a) {
  color: #8c1d40;
  text-decoration: underline;
}

.notification-body :deep(ul),
.notification-body :deep(ol) {
  padding-left: 24px;
  margin: 8px 0;
}
</style>
